<template>
    <div class="control-panel-wrapper">
        <div class="control-panel">
            <div class="station sector">
                <div class="station title">{{ $t('control-panel.station') }}</div>
                <hr />
                <select
                    name="weatherStation"
                    class="content-block"
                    v-model="weatherStation"
                    @change="update()"
                >
                    <option v-for="station in StationList" :key="station.id" :value="station.id">
                        {{ $t(`station-name.${station.id}`) }}
                    </option>
                </select>
                <TimeIntervalButton class="button content-block" device="mobile" />
            </div>
            <div class="latest sector">
                <div class="latest title">{{ $t('control-panel.latest') }}</div>
                <hr />
                <div class="latest date content-block">
                    {{ latestDate.yyyy_MM_dd }}
                </div>
                <div class="latest time content-block">
                    {{ latestDate.hh_mm }}
                </div>
            </div>
            <div class="history sector">
                <div class="history title">{{ $t('control-panel.history') }}</div>
                <hr />
                <input
                    class="history date content-block"
                    type="date"
                    :max="latestDate.yyyy_MM_dd"
                    v-model="date"
                    @change="update(true)"
                />
                <select
                    class="history time content-block"
                    name="time"
                    v-model="time"
                    @change="update()"
                >
                    <option v-for="timeSeries in timeSeriesList" :key="timeSeries">
                        {{ timeSeries }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { StationList, resolvePreviewMoment } from '@/constants'
import DownloadButton from '@/components/desktop/DownloadButton.vue'
import TimeIntervalButton from '@/components/common/TimeIntervalButton.vue'
export default {
    name: 'ControlPanelM',
    components: {
        DownloadButton,
        TimeIntervalButton,
    },
    data() {
        return {
            weatherStation: 'ys',
            date: new Date().toISOString().slice(0, 10),
            time: '00:00',
        }
    },
    computed: {
        ...mapState(['selectedStation', 'selectedDate', 'timeSeriesList', 'latestData']),
        StationList() {
            return StationList
        },
        latestDate() {
            if (!this.latestData || !this.latestData['DateTime'])
                return { yyyy_MM_dd: '--', hh_mm: '--' }
            const dateObj = new Date(this.latestData['DateTime'])
            return {
                yyyy_MM_dd: dateObj
                    .toLocaleDateString([], {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    })
                    .replaceAll('/', '-'),
                hh_mm: dateObj.toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                    hourCycle: 'h23',
                }),
            }
        },
    },
    methods: {
        ...mapMutations(['setSelectedStation', 'setSelectedDate']),
        ...mapActions([
            'fetchLatestData',
            'fetchHistoryData',
            'fetchTimeSeriesList',
            'fetchGPSPivot',
        ]),
        // 指定了 previewMoment 的站點停在那一刻，其餘停在最新一筆
        resetSelectionAndUpdate() {
            const preview = resolvePreviewMoment(this.weatherStation)
            this.date = preview ? preview.slice(0, 10) : this.latestDate.yyyy_MM_dd
            this.time = preview ? preview.slice(11, 16) : this.latestDate.hh_mm
            this.update()
        },
        // updates the view with selected station and date
        async update(setDefaultTime = false) {
            // 換站時要把日期撥到該站最後一筆，理由與桌面版 ControlPanel 相同
            const stationChanged = this.weatherStation !== this.selectedStation
            this.setSelectedStation(this.weatherStation)
            if (stationChanged) {
                await this.fetchLatestData()
                return
            }
            const selectedDate = new Date(this.date)

            this.setSelectedDate(selectedDate)

            await this.fetchTimeSeriesList()
            if (setDefaultTime) {
                this.time = this.timeSeriesList[0]
            }
            const timeArr = this.time.split(':')
            selectedDate.setHours(timeArr[0])
            selectedDate.setMinutes(timeArr[1])

            await Promise.all([this.fetchHistoryData(), this.fetchGPSPivot()])
        },
    },
    watch: {
        latestDate() {
            // console.log('New data arrived, updating view...')
            this.resetSelectionAndUpdate()
        },
    },
}
</script>

<style lang="scss" scoped>
.control-panel-wrapper {
    height: 100%;
    width: 100%;

    // background-color: #edf1ef;
    border: #8aaba1 solid 1px;
    border-radius: 8px;

    hr {
        width: 96%;
        border: #8aaba1 solid 0.5px;
        margin: 2px;
        @media (orientation: landscape) {
            display: none;
        }
    }
    .control-panel {
        @media (orientation: portrait) {
            height: max-content;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: flex-start;
            overflow-x: auto;
        }
        @media (orientation: landscape) {
            display: flex;
            flex-direction: column;
            overflow-x: auto;
        }
        .sector {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-content: space-between;
            margin: 0.2rem;
            @media (orientation: portrait) {
                height: 6rem;
            }
            @media (orientation: landscape) {
                height: fit-content;
                margin: 0.2rem 0;
                &.history {
                    margin: 0 0.4rem;
                    align-self: center;
                }
            }
        }
        .title {
            font-size: 1rem;
            font-weight: bold;
            text-align: center;
            white-space: nowrap;
            margin: 0.3rem 0;
        }
        .content-block {
            font-family: Avenir, Helvetica, Arial, sans-serif;
            color: black;
            font-size: 0.8rem;

            border: none;
            border-radius: 4px;
            padding: 0.2rem 0.5rem;
            margin: 0.2rem 0;
            text-align: center;
            white-space: nowrap;

            align-self: center;
        }
    }
}

// scroll bar
/* Vertical scrollbar */
::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-track {
    background: #dddddd;
    -webkit-border-radius: 10px;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: #888;
    -webkit-border-radius: 5px;
    border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Horizontal scrollbar */
::-webkit-scrollbar:horizontal {
    height: 5px;
}

::-webkit-scrollbar-thumb:horizontal {
    background-color: #888;
}

::-webkit-scrollbar-thumb:horizontal:hover {
    background-color: #555;
}

::-webkit-scrollbar-track:horizontal {
    background-color: #dddddd;
}
</style>
